import KeyMirror from 'keymirror';

export default KeyMirror({
    SET_CURRENT_REPORT_DATA: true,
});
